import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.agricampanha.agr.br';
const DEFAULT_OG_IMAGE = `${SITE_URL}/img/og-image.jpg`;
const SITE_NAME = 'Agricampanha';
const TWITTER_HANDLE = '@agricampanha';

interface PageMetaProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article';
  noIndex?: boolean;
  jsonLd?: object;
}

const PageMeta: React.FC<PageMetaProps> = ({
  title,
  description = 'Associação dos Agricultores da Região da Campanha, representando e fortalecendo os produtores rurais de Bagé/RS.',
  image = DEFAULT_OG_IMAGE,
  url,
  type = 'website',
  noIndex = false,
  jsonLd,
}) => {
  const fullTitle = title
    ? `${title} | ${SITE_NAME}`
    : `${SITE_NAME} - Sempre ao lado do produtor`;

  const canonicalUrl = url ? `${SITE_URL}${url}` : undefined;
  const ogImage = image.startsWith('http') ? image : `${SITE_URL}${image}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content={fullTitle} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={TWITTER_HANDLE} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default PageMeta;
